import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const marketEnvironmentSelection = {
    name: "Market Environment Selection",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose Market Environment",
    defaultConfig: {
        defaultValue: null,
        key: "Market Environment",
    },
    type: "input",
    category: "dashboard",
};
